<template>
  <section>
    <h2 class="mt-5">
      <i18n path="common.example" />
      <small class="ms-3">
        <!--<i18n path="region.demo.desc"></i18n>-->
        <a
          href="https://codepen.io/terry05/pen/ERNvzJ"
          target="_blank"
        >
          <i18n path="common.codePen" />
        </a>
      </small>
    </h2>

    <section>
      <h3 class="mt-5">
        Selects <i18n path="region.demo.modes.formElement" />
      </h3>
      <div class="card p-5 shadow-sm">
        <h5>
          <i18n path="region.demo.province" />
        </h5>
        <region-selects
          :city="false"
          :area="false"
        />
        <showcode>
          <v-code>
            <pre>
            &lt;region-selects
              :city="false"
              :area="false"
              v-model="region"
            /&gt;

            &lt;script&gt;
            import { RegionSelects } from 'v-region'

            export default {
              components: {
                RegionSelects
              },
              data () {
                return {
                  region: {}
                }
              }
            }
            &lt;/script&gt;
            </pre>
          </v-code>
        </showcode>

        <h5 class="mt-3">
          <i18n path="region.demo.province" />、
          <i18n path="region.demo.city" />
        </h5>
        <region-selects :area="false" />
        <showcode>
          <v-code>
            <pre>
            &lt;region-selects
              :area="false"
              v-model="region"
            /&gt;
            </pre>
          </v-code>
        </showcode>

        <h5 class="mt-3">
          <i18n path="region.demo.province" />、
          <i18n path="region.demo.city" />、
          <i18n path="region.demo.area" />
        </h5>
        <region-selects />
        <showcode>
          <v-code>
            <pre>
            &lt;!-- 默认为启用省、市、区/县级别 --&gt;
            &lt;region-selects
              v-model="region"
            /&gt;

            </pre>
          </v-code>
        </showcode>

        <h5 class="mt-3">
          <i18n path="region.demo.province" />、
          <i18n path="region.demo.city" />、
          <i18n path="region.demo.area" />、
          <i18n path="region.demo.town" />
        </h5>
        <div>
          <i18n path="region.demo.selected" />:
        </div>
        <pre class="p-3 bg-light rounded-3">{{ JSON.stringify(selectResult, null, 2) }}</pre>
        <region-selects
          :town="true"
          @change="selectLogs"
        />
        <showcode>
          <v-code>
            <pre>
            &lt;region-selects
              :town="true"
              v-model="region"
              @change="selectLogs"
            /&gt;
            </pre>
          </v-code>
        </showcode>

        <h5 class="mt-3">
          <i18n path="region.demo.init" />
        </h5>
        <region-selects
          :town="true"
          v-model="selected"
        />
        <showcode>
          <v-code>
            <pre>
            &lt;region-selects
              :town="true"
              v-model="region"
            /&gt;

            &lt;script&gt;
            export default {
              data () {
                return {
                  region: {
                    province: '350000',
                    city: '350100',
                    area: '350104',
                    town: '350104008'
                  }
                }
              }
            }
            &lt;/script&gt;
            </pre>
          </v-code>
        </showcode>

        <h5 class="mt-3">
          <i18n path="region.demo.disabled" />
        </h5>
        <region-selects
          :town="true"
          :disabled="true"
          v-model="selected"
        />
        <showcode>
          <v-code>
            <pre>
            &lt;region-selects
              :town="true"
              :disabled="true"
              v-model="region"
            /&gt;
            </pre>
          </v-code>
        </showcode>
      </div>
    </section>

    <section>
      <h3 class="mt-5">
        Text <i18n path="region.demo.modes.plainText" />
      </h3>
      <div class="card p-5 shadow-sm">
        <h5>
          <i18n path="region.demo.text" />
        </h5>
        <div class="bg-light rounded-3 p-3">
          <region-text v-model="selected" />
        </div>
        <showcode>
          <v-code>
            <pre>
            &lt;region-text v-model="region" /&gt;

            &lt;script&gt;
            export default {
              data () {
                return {
                  region: {
                    province: '350000',
                    city: '350100',
                    area: '350104',
                    town: '350104008'
                  }
                }
              }
            }
            &lt;/script&gt;
            </pre>
          </v-code>
        </showcode>

        <h5>
          <i18n path="region.demo.textSeparator" />
        </h5>
        <div class="bg-light rounded-3 p-3">
          <region-text
            separator="-"
            v-model="selected"
          />
        </div>
        <showcode>
          <v-code>
            <pre>
            &lt;region-text
              separator="-"
              v-model="region"
            /&gt;
            </pre>
          </v-code>
        </showcode>
      </div>
    </section>

    <section>
      <h3 class="mt-5">
        Columns <i18n path="region.demo.columns.title" />
      </h3>
      <div class="card p-5 shadow-sm">
        <h5 class="">
          <i18n path="region.demo.modes.selector" />
        </h5>
        <div>
          <region-columns
            :town="true"
          />
        </div>
        <showcode>
          <v-code>
            <pre>
            &lt;!-- Use default toggle button --&gt;
            &lt;region-columns
              :town="true"
              v-model="region"
            /&gt;

            &lt;script&gt;
            import { RegionColumns } from 'v-region'

            export default {
              components: {
                RegionColumns
              },
              data () {
                return {
                  region: {
                    province: '350000',
                    city: '350100',
                    area: '350104',
                    town: '350104008'
                  }
                }
              }
            }
            &lt;/script&gt;
            </pre>
          </v-code>
        </showcode>

        <h5 class="mt-3">
          <i18n path="region.demo.columns.base" />
        </h5>
        <div class="rounded-3 border">
          <region-columns-core
            :town="true"
          />
        </div>
        <showcode>
          <v-code>
            <pre>
            &lt;region-columns-core
              :town="true"
              v-model="region"
            /&gt;

            &lt;script&gt;
            import { RegionColumnsCore } from 'v-region'

            export default {
              components: {
                RegionColumnsCore
              },
              ...
            }
            &lt;/script&gt;
            </pre>
          </v-code>
        </showcode>

        <h5 class="mt-3">
          <i18n path="region.demo.customCaller" />(Scoped Slots)
        </h5>
        <div>
          <region-columns
            :town="true"
          >
            <template #default="{ region, show }">
              <button
                type="button"
                class="btn btn-success"
              >
                region:{{ resultText(region) }},
                show: {{ show }}
              </button>
            </template>
          </region-columns>
        </div>
        <showcode>
          <v-code>
            <pre>
            &lt;region-columns
              :town="true"
              v-model="region"
            &gt;
              &lt;template #default="{ region, show }"&gt;
                &lt;button
                  type="button"
                  class="btn btn-success"
                &gt;
                  region: &lt;span v-text="handle(region)" /&gt;,
                  show: &lt;span v-text="show" /&gt;
                &lt;/button&gt;
              &lt;/template&gt;
            &lt;/region-columns&gt;

            &lt;script&gt;
            import { RegionColumns } from 'v-region'

            export default {
              components: {
                RegionColumns
              },
              data () {
                return {
                  region: {
                    province: '350000',
                    city: '350100',
                    area: '350104',
                    town: '350104008'
                  }
                }
              }
            }
            &lt;/script&gt;
            </pre>
          </v-code>
        </showcode>
      </div>
    </section>

    <h3 class="mt-5">
      Group <i18n path="region.demo.group.title" />
    </h3>
    <div class="card p-5 shadow-sm">
      <h4>
        <i18n path="region.demo.modes.selector" />
      </h4>
      <div>
        <region-group
          :town="true"
          @change="regionChange"
        />
      </div>
      <showcode>
        <v-code>
          <pre>
            &lt;!-- Use default toggle button --&gt;
            &lt;region-group
              :town="true"
              v-model="region"
              @change="change"
            /&gt;

            &lt;script&gt;
            import { RegionGroup } from 'v-region'

            export default {
              components: {
                RegionGroup
              },
              data () {
                return {
                  region: {
                    province: '350000',
                    city: '350100',
                    area: '350104',
                    town: '350104008'
                  }
                }
              },
              methods: {
                change (data) {
                  console.log(data)
                }
              }
            }
            &lt;/script&gt;
          </pre>
        </v-code>
      </showcode>

      <h5 class="mt-3">
        <i18n path="region.demo.group.base" />
      </h5>
      <div>
        <region-group-core
          class="rounded-3 border"
          :town="true"
        />
      </div>
      <showcode>
        <v-code>
          <pre>
            &lt;region-group-core
              :town="true"
              v-model="region"
            /&gt;

            &lt;script&gt;
            import { RegionGroupCore } from 'v-region'

            export default {
              components: {
                RegionGroupCore
              },
              ...
            }
            &lt;/script&gt;
            </pre>
        </v-code>
      </showcode>

      <h5 class="mt-3">
        <i18n path="region.demo.customCaller" />(Scoped Slots)
      </h5>
      <div>
        <region-group
          :town="true"
          @change="regionChange"
        >
          <template #default="{ region, show }">
            <button
              type="button"
              class="btn btn-success"
            >
              region:{{ resultText(region) }},
              show: {{ show }}
            </button>
          </template>
        </region-group>
      </div>
      <showcode>
        <v-code>
          <pre>
          &lt;!-- Customize region toggle --&gt;
          &lt;region-group
            :town="true"
            v-model="region"
            @change="regionChange"
          &gt;
            &lt;template #default="{ region, show }"&gt;
              &lt;button
                type="button"
                class="btn btn-success"
              &gt;
                region: &lt;span v-text="handle(region)" /&gt;,
                show: &lt;span v-text="show" /&gt;
              &lt;/button&gt;
            &lt;/template&gt;
          &lt;/region-group&gt;
          </pre>
        </v-code>
      </showcode>
    </div>

    <section>
      <h3 class="mt-5">
        CityPicker <i18n path="region.demo.cityPicker" />
      </h3>
      <div class="card p-5 shadow-sm">
        <div>
          <region-city-picker
            v-model="selectedCitys"
            @change="citySelectedLogs"
          />
        </div>

        <pre class="p-3 bg-light mt-3 rounded-3 mb-0">{{ JSON.stringify(selectedCityResult, null, 2) }}</pre>

        <showcode>
          <v-code>
            <pre>
            &lt;region-city-picker
              v-model="selected"
              @change="change"
            /&gt;

            &lt;script&gt;
            import { RegionCityPicker } from 'v-region'

            export default {
              components: {
                RegionCityPicker
              },
              data () {
                return {
                  // take city codes to make the corresponding city items selected
                  selected: ['110000', '130200', '140100']
                }
              },
              methods: {
                // item selected callback
                // data format:
                // [
                //   { key: string, value: string },
                //   ...
                // ]
                change (data) {
                  console.log(data)
                }
              }
            }
            &lt;/script&gt;
            </pre>
          </v-code>
        </showcode>
      </div>
    </section>
  </section>
</template>

<script>
import {
  RegionText,
  RegionCityPicker,
  RegionSelects,
  RegionColumnsCore,
  RegionColumns,
  RegionGroupCore,
  RegionGroup
} from 'v-region'

export default {
  components: {
    RegionText,
    RegionCityPicker,
    RegionSelects,
    RegionColumnsCore,
    RegionColumns,
    RegionGroupCore,
    RegionGroup
  },
  data () {
    return {
      selected: {
        province: '350000',
        city: '350100',
        area: '350104',
        town: '350104008'
      },
      selectedCitys: ['110000', '130200', '140100'],
      selectResult: {},
      selectedCityResult: []
    }
  },
  methods: {
    resultText (region) {
      if (!region || !Object.values(region).some(val => val)) return '无数据'
      return Object.values(region).filter(val => val).map(val => val.value).join(',')
    },
    regionChange (d) {
      console.log(d)
    },
    getValue (obj) {
      return obj ? obj.value : ''
    },
    selectLogs (data) {
      if (data) this.selectResult = data
    },
    citySelectedLogs (datas) {
      if (datas && datas.length) this.selectedCityResult = datas
    }
  }
}
</script>
